import { IGlobalState } from './types';
import { ThemeList } from '../globalTypes';
const initialGlobalState = (): IGlobalState => ({
  error: null,
  loading: false,
  scheme: (localStorage.getItem('theme') as ThemeList) || ThemeList.MAIN_THEME,
  searchParams: '',
  filtersData: [],
  filtersDataLei: [],
  appliedFiltersResult: [],
  tableFilters: {
    applicability: ['all'],
  },
  selectedOption99: '',
  superAdmin: false,
});

export default initialGlobalState;
